import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

const latest = [...mediaList].sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1)).slice(0, 12);

export default function LatestSection() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14" aria-label="最新上映">
      <SectionHeading
        eyebrow="持续更新"
        title="最新上映"
        desc="紧跟院线与剧集更新节奏，第一时间为你呈现高分新作与热门连载。"
        moreTo="/category/movie"
        moreLabel="更多影视"
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
        {latest.map((item) => (
          <MovieCard key={item.id} item={item} />
        ))}
      </div>
      <div className="mt-6 text-center">
        <Link
          to="/search?q=2025"
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
        >
          浏览更多新片
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}